import { render, staticRenderFns } from "./listService.vue?vue&type=template&id=2331a277&"
import script from "./listService.vue?vue&type=script&lang=js&"
export * from "./listService.vue?vue&type=script&lang=js&"
import style0 from "./listService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports